module.exports = __webpack_public_path__ + "img/shuangruan.6f8bda49.png";